import { FC } from 'react';
import {
  Modal, Box, Typography,
} from '@mui/material';
import ReactPlayer from 'react-player';
import { mdiCloseCircleOutline } from '@mdi/js';
import IconButton from '@mui/material/IconButton';
import Icon from '@mdi/react';

type TVideoModal = {
  isOpenModal: boolean
  setIsOpenModal: (val: boolean) => void
  videoTitle: string
  videoLink: string
};

const VideoModal: FC<TVideoModal> = ({
  isOpenModal, setIsOpenModal, videoTitle, videoLink,
}) => (
  <Modal
    open={isOpenModal}
    aria-labelledby="video-modal-title"
    aria-describedby="video-modal-description"
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box sx={{
      position: 'relative',
      width: '80%',
      height: '70%',
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 2,
      outline: 'none',
      display: 'flex',
      flexDirection: 'column',
    }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography id="video-modal-title" variant="h6" component="h2">
          {videoTitle}
        </Typography>
        <IconButton onClick={() => setIsOpenModal(false)}>
          <Icon path={mdiCloseCircleOutline} size={1} />
        </IconButton>
      </Box>
      <Box sx={{ flexGrow: 1, mt: 2 }}>
        <ReactPlayer
          url={videoLink}
          playing
          controls
          width="100%"
          height="100%"
        />
      </Box>
    </Box>
  </Modal>
);

export { VideoModal };
